const autoScrollActions = new Set(['POP', 'REPLACE', 'PUSH'])

export const shouldAutoScroll = (location, history) =>
  autoScrollActions.has(history.action) && Boolean(location.hash)
